import React, {forwardRef, useEffect, useState} from "react";
import './VisualThumb.css'
import {
    ARRAY_DEFAULT_PROJECT_ITEM_THUMB_1,
    ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG,
    MAP_DEFAULT_PROJECT_ITEM_THUMB_BIG_COLOR
} from "@/Const";
import {isDarkMode} from "@/utils";

const VisualThumb = forwardRef((props:{from:any,marginBottom:any,data:any,randomKey:any},ref)=>{
    const [backgroundColor,setBackgroundColor] = useState('transparent');
    const [, updateState] = useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);

    // useEffect(() => {
    //     window.refreshList['updateTheme_visualThumb_'+props.data.id] = forceUpdate;
    //     console.log('uuuuuuu')
    //
    //     return ()=>{
    //         delete window.refreshList['updateTheme_visualThumb'+props.data.id]
    //     }
    // }, []);

    useEffect(() => {
        let szThumbUrl = props.data.thumbUrl;
        //旧的全部换成新的.
        let nOldIndex = ARRAY_DEFAULT_PROJECT_ITEM_THUMB_1.findIndex(p=>props.data.thumbUrl.includes(p));
        if (nOldIndex != -1){
            if (nOldIndex >= ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG.length){
                nOldIndex = 0;
            }
            szThumbUrl = ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG[nOldIndex];
        }

        const item = MAP_DEFAULT_PROJECT_ITEM_THUMB_BIG_COLOR[szThumbUrl];
        if (item){
            setBackgroundColor(isDarkMode()?item.dark+'':item.light);
        }
    }, [props.data.thumbUrl,props.randomKey]);

    return <div className={'visual-thumb-item'} key={props.randomKey} style={{paddingBottom:`${props.marginBottom+12}px`,background:backgroundColor}}>
        <div className={'visual-thumb-item-container'}>
            <div>
                <div className={'visual-thumb-item-container-bar-1'}></div>
                <div className={'visual-thumb-item-container-bar-2'}></div>
                <div className={'visual-thumb-item-container-bar-3'}></div>
            </div>
            <div>
                <div className={'visual-thumb-item-container-bar-1'}></div>
                <div className={'visual-thumb-item-container-bar-3'}></div>
            </div>
            <div>
                <div className={'visual-thumb-item-container-bar-1'}></div>
                <div className={'visual-thumb-item-container-bar-2'}></div>
                <div className={'visual-thumb-item-container-bar-3'}></div>
            </div>
        </div>

    </div>
})

export default VisualThumb;